import React from 'react';

export default function CohortHeatmap({ cohorts }) {
  if (!cohorts || !cohorts.cohorts || cohorts.cohorts.length === 0) {
    return <div style={{ color: 'var(--text-muted)', padding: 40, textAlign: 'center', fontSize: 13 }}>Нет данных</div>;
  }
  const data = cohorts.cohorts;
  const maxPeriods = Math.max(...data.map((c) => (c.periods_after || []).length));

  const cellColor = (rate) => {
    if (rate == null) return 'transparent';
    const r = Math.min(rate / 100, 1);
    const hue = 187;
    return `hsla(${hue}, 82%, ${52 - r * 20}%, ${0.12 + r * 0.5})`;
  };

  return (
    <div style={{ overflowX: 'auto', borderRadius: 12, border: '1px solid var(--border)', background: 'var(--bg-card)' }}>
      <table style={{ borderCollapse: 'collapse', fontSize: 12, width: '100%' }}>
        <thead>
          <tr>
            <th style={styles.th}>Когорта</th>
            <th style={styles.th}>Всего</th>
            {Array.from({ length: maxPeriods }, (_, i) => (
              <th key={i} style={styles.th}>+{i + 1}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {data.map((c, ri) => (
            <tr key={ri}>
              <td style={{ ...styles.td, fontWeight: 600, color: 'var(--text-secondary)' }}>{c.cohort}</td>
              <td style={{ ...styles.td, fontWeight: 600, fontVariantNumeric: 'tabular-nums' }}>{c.total_clients}</td>
              {Array.from({ length: maxPeriods }, (_, pi) => {
                const p = (c.periods_after || [])[pi];
                const rate = p ? p.retention_rate : null;
                return (
                  <td key={pi} style={{
                    ...styles.td,
                    background: cellColor(rate),
                    textAlign: 'center',
                    fontWeight: rate != null && rate > 50 ? 700 : 500,
                    fontVariantNumeric: 'tabular-nums',
                  }}>
                    {rate != null ? `${rate.toFixed(0)}%` : ''}
                  </td>
                );
              })}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

const styles = {
  th: {
    padding: '10px 12px', color: 'var(--text-muted)',
    borderBottom: '1px solid var(--border)', fontWeight: 600,
    whiteSpace: 'nowrap', textAlign: 'center',
    fontSize: 10, textTransform: 'uppercase', letterSpacing: 0.5,
  },
  td: {
    padding: '8px 12px', color: 'var(--text-primary)',
    borderBottom: '1px solid var(--border)', whiteSpace: 'nowrap',
  },
};
